"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dsWeb = require("@olxbr/ds-web");
var _propTypes = require("prop-types");
var _style = require("../../style");
var _jsxRuntime = require("react/jsx-runtime");
var GoItButton = function GoItButton(_ref) {
  var button = _ref.button,
    rating = _ref.rating,
    close = _ref.close;
  return button && !rating && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.BubbleButton, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
      onClick: function onClick() {
        return close();
      },
      size: "medium",
      variant: "primary",
      children: button.title
    })
  });
};
GoItButton.propTypes = {
  title: _propTypes.string.isRequired,
  rating: _propTypes.object,
  close: _propTypes.func.isRequired
};
var _default = exports["default"] = GoItButton;